<template>
  <v-container v-show="cargando" style="border-bottom_: 1px solid orange">
    <v-row>
      <v-col class="col-sm-12 col-md-7">
        <div class="display-1">{{ $t("inicioNombreParking") }}</div>
        <div class="subtitle-1">{{ $t("presentacionPubli") }}</div>
        <!-- Añadido para informacion adicional -->
        <!-- <div class="subtitle-2">{{ $t("presentacionInfo") }}</div> -->
        <v-container>
          <v-card
            class="subtitle-1_ elevation-12"
            style="background: #fad063; color: black"
          >
            <v-card-title style="margin-top: 20px">
              <v-row>
                <v-col col="8">
                  {{ $t("datosReservaTitulo") }}
                </v-col>
                
                <v-col col="4" align="right" v-if="tiempoRestanteReserva != ''">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div
                        v-bind="attrs"
                        v-on="on"
                        style="border-radius: 15px; border: 1px solid black; width: 40%; font-weight: 800;"
                        align="center"
                      >
                        {{ tiempoRestanteReserva }}
                      </div>
                    </template>
                    <span>{{ $t('tiempoTextoTooltip') }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-card-title>
            <form @submit.prevent="">
              <div class="form-group entradaDatosVarios">
                <v-row>
                  <v-col cols="11">
                    <v-select
                      dense
                      color="secundary"
                      outlined
                      :label="labelCiudadSeleccionada"
                      v-model="ciudadSeleccionada"
                      @change="obtenerParkingsDespuuesDeSeleccionarCiudad"
                      :items="itemsCiudad"
                    ></v-select>
                  </v-col>
                  <v-col cols="11">
                    <v-select
                      dense
                      color="secundary"
                      outlined
                      :label="labelParkingSeleccionado"
                      ref="parking"
                      v-model="parkingseleccionado"
                      :rules="[() => !!parkingseleccionado || reglasInicio]"
                      required
                      :items="itemsParkings"
                    ></v-select>
                  </v-col>
                  <v-col cols="auto">
                    <label style="margin-bottom: 0px" for="fechaEntrada">{{
                      $t("datosReservaFechaEntrada")
                    }}</label>
                    <v-row
                      align="center"
                      justify="start"
                      style="padding-top: 7px; padding-left: 14px"
                    >
                      <SelectorFechaHora
                        :required="true"
                        :monday-first="true"
                        v-model="fechaEntrada"
                        class="form-control_"
                      />
                    </v-row>
                  </v-col>
                </v-row>
              </div>

              <div class="form-group entradaDatosVarios">
                <label style="margin-bottom: 0px" for="fechaSalida">{{
                  $t("datosReservaFechaSalida")
                }}</label>

                <v-row>
                  <v-col cols="auto">
                    <v-row
                      align="center"
                      justify="start"
                      style="padding-top: 7px; padding-left: 14px"
                    >
                      <SelectorFechaHora
                        :monday-first="true"
                        v-model="fechaSalida"
                        class="form-control_"
                      />
                    </v-row>
                  </v-col>
                </v-row>
              </div>

              <div class="form-group entradaDatosUnico">
                <v-alert
                  style="margin-bottom: 10px"
                  :value="alerta.mostrar"
                  color="brown"
            
                  border="top"
                  icon="mdi-home"
                  transition="scale-transition"
                >
                  {{ this.alerta.texto }}
                </v-alert>
                <!-- para mostrar mensaje de error de fechas -->
              </div>

              <div class="form-group entradaDatosUnico">
                <v-text-field
                  outlined
                  ref="matricula"
                  :rules="[() => !!datosReserva.matricula || reglasInicio]"
                  required
                  dense
                  color="secundary"
                  :label="$t('datosReservaMatricula')"
                  v-model="datosReserva.matricula"
                ></v-text-field>
              </div>
              <div class="form-group entradaDatosUnico">
                <v-text-field
                  outlined
                  dense
                  ref="modelo"
                  :rules="[() => !!datosReserva.modelo || reglasInicio]"
                  required
                  color="secundary"
                  :label="$t('datosReservaModelo')"
                  
                  v-model="datosReserva.modelo"
                ></v-text-field>
              </div>
              <div class="form-group entradaDatosUnico">
                <v-switch  v-model="swCodigoPromocional" color="green"  hide-details :label="$t('tienesCodigoPromocional')">
                  <template v-slot:label>
                      <span class="v-label-black mt-2" >{{$t('tienesCodigoPromocional')}}</span>
                  </template>
                </v-switch>
              </div> 

              <!-- CODIGO PROMOCIONAL. DESCOMENTAR PARA HACER USO  -->
              <div class="form-group entradaDatosUnico" v-if="swCodigoPromocional">
                      <v-text-field class="mt-2"  outlined dense   color="secundary" :label="$t('datosReservaPromocion')"  @keypress.enter="reservar()" v-model="codigoPromocional"></v-text-field>
                      <label  v-show="!valido" style="color:red">{{informacionCodigoPromocional}}</label>
                      <label  v-show="valido" style="color:green">{{informacionCodigoPromocional}}</label>
                    </div>
              <!-- <div class="form-group entradaDatosUnico" >
                      <v-text-field outlined dense  required dark :label="$t('datosReservaPromocion')"  @keypress.enter="reservar()" v-model="codigoPromocional"></v-text-field>
                    </div> -->
              <div class="entradaDatosImporte2">
                <div>
                  <v-row align="center" justify="center">
                    <v-col align="start">
                      <label>{{ $t("datosReservaPrecioTotal") }}</label>
                    </v-col>

                    <v-col align="end">
                      <label>{{
                        datosReserva.importeReservaSinPromocion
                      }}</label>
                    </v-col>
                  </v-row>
                </div>
                <div
                  v-show="!datosReserva.importeDescuento"
                  style="border-bottom: 1px solid #fad063"
                ></div>

                
                <div
                  v-show="datosReserva.importeDescuento"
                  style="border-bottom: 1px solid #fad063"
                >
                  <v-row align="center" justify="center">
                    <v-col align="start">
                      <label>{{ $t("descuentoCodigoPromocional") }}</label>
                    </v-col>

                    <v-col align="end">
                      <label>{{ datosReserva.importeDescuento }}</label>
                    </v-col>
                  </v-row>
                </div>
                <div>
                  <v-row align="center" justify="center">
                    <v-col align="start">
                      <label class="importeTotalFinalTitulo">{{
                        $t("datosReservaTotal")
                      }}</label>
                    </v-col>

                    <v-col v-show="verPrecioTotal" align="end">
                      <label class="importeTotalFinal">{{
                        datosReserva.importeReserva
                      }}</label>
                    </v-col>
                  </v-row>
                </div>

                <div>
                  <v-alert
                    style="margin-bottom: 10px"
                    :value="alertaDisponibilidad.mostrar"
                    color="pink"
                    dark
                    border="top"
                    icon="mdi-home"
                    transition="scale-transition"
                  >
                    {{ this.alertaDisponibilidad.texto }}
                  </v-alert>
                  <!-- para mostrar mensaje de error de comunicaciones/disponibilidad -->
                </div>

                <div class="form-group">
                  <v-overlay v-model="dialog">
                    <v-progress-circular
                      size="120"
                      width="12"
                      color="red"
                      indeterminate
                      justify="center"
                      align="center"
                    >
                    </v-progress-circular>
                  </v-overlay>
                  <!-- indicador de espera para la obtencion de disponibilidad de plazas -->

                  <v-btn
                    class="mx-auto"
                    color="#fad063"
                    elevation="24"
                    
                    :disabled="btnDisabled"
                    @click="reservar()"
                    outlined
                  >
                    {{ $t("btnReservar") }}
                    <v-icon class="ml-4" dark> mdi-check </v-icon>
                  </v-btn>
                </div>
              </div>
            </form>
            <!-- fin formulario datos reserva -->
          </v-card>
          <!-- fin titulo Completa tu reserva -->

          <v-container class="pa-0 ma-0"> </v-container>
        </v-container>
      </v-col>
      <v-col class="col-sm-12 col-md-5">
        <div class="display-1">{{ $t("informacionParking") }}</div>
        <span v-if="parkingseleccionado == 'Parking Luna centro'"
          ><v-icon>mdi-map-marker</v-icon
          ><a :href="linkComoLlegarParkingLunaCentro" target="_blank">{{
            $t("comollegar")
          }}</a></span
        >
        <span v-else-if="parkingseleccionado == 'Parking Luna de Granada'"
          ><v-icon>mdi-map-marker</v-icon
          ><a :href="linkComoLlegarParkingLunaGranada" target="_blank">{{
            $t("comollegar")
          }}</a></span
        >

        <v-img
          v-if="parkingseleccionado == 'Parking Luna centro'"
          class="mt-2"
          src="@/assets/mapalunacentro.jpg"
        ></v-img>
        <v-img
          v-else-if="parkingseleccionado == 'Parking Luna de Granada'"
          class="mt-2"
          src="@/assets/mapalunagranada.png"
        ></v-img>
        <v-carousel
          v-if="parkingseleccionado == 'Parking Luna centro'"
          class="elevation-12 mt-2"
          cycle
          height="315"
          interval="3500"
          hide-delimiters
          style="max-height: 315px"
        >
          <v-carousel-item src="@/assets/centro.jpg"></v-carousel-item>
          <v-carousel-item src="@/assets/centro2.jpg"></v-carousel-item>
          <v-carousel-item src="@/assets/centro3.jpg"></v-carousel-item>
          <v-carousel-item src="@/assets/centro4.jpg"></v-carousel-item>
          <v-carousel-item src="@/assets/centro5.jpg"></v-carousel-item>
          <v-carousel-item src="@/assets/centro6.jpg"></v-carousel-item>

        </v-carousel>
        <v-carousel
          v-else-if="parkingseleccionado == 'Parking Luna de Granada'"
          class="elevation-12 mt-2"
          cycle
          height="315"
          interval="3500"
          hide-delimiters
          style="max-height: 315px"
        >
          <v-carousel-item src="@/assets/granada.jpg"></v-carousel-item>
          <v-carousel-item src="@/assets/granada1.jpg"></v-carousel-item>
          <v-carousel-item src="@/assets/granada2.jpg"></v-carousel-item>
          <v-carousel-item src="@/assets/granada3.jpg"></v-carousel-item>


        </v-carousel>
        <!--Tiempo-->
        <v-card class="elevation-12 mt-2">
          <v-toolbar dark color="black">
            <v-toolbar-title>{{ ciudadSeleccionada }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text class="text-xs-center">
            <v-row>
              <span class="display-3 cursor-manita contenedor-temperatura ml-4">
                {{ Math.round(temperatura) }}°
              </span>
              <v-img
                :src="iconoTemperatura"
                max-height="75"
                max-width="100"
              ></v-img>
            </v-row>
            <span class="headline"
              >Max: {{ Math.round(temperaturaMaxima) }}°</span
            >
            <span class="headline ml-5"
              >Min: {{ Math.round(temperaturaMinima) }}°</span
            >
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>


  </v-container>
</template>


<style scoped>
/* ATENCION:
  No se puede cambiar directamente los estilos del timepicker; así que he alterado el archivo
  'vue2-timepicker/dist/VueTimepicker.css' para que el color con el que se indica la seleccion
  de una hora/minuto sea el mismo que en el datepicker; tambien para que no aparezca un borde
  alrededor de la hora */

/* con esto consigo el cambio de color en cada una de las lineas de la tabla */
table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  border: 1px solid #ddd;
}
th,
td {
  text-align: left;
  padding: 10px;
}

tr:nth-child(odd) {
  background-color: #eeeeee;
  border-left_: 1px solid #000000;
}

/* esto elimina el efecto de resaltar las lineas de la tabla segun
  muevo el raton sobre ellas (hover) */
tr:nth-child(odd):hover {
  background-color: #eeeeee !important;
  border-left: 1px solid orange;
}

tr:nth-child(even):hover {
  background-color: #ffffff !important;
  border-left_: 1px solid orange;
}

/* Datos de reserva */
.entradaDatosVarios {
  margin-left: 20px;
}

.v-label-white {
  color: white;
}
.entradaDatosUnico {
  margin-left: 20px;
  margin-right: 20px;
}

.entradaDatosImporte1 {
  background-color: #804010;
  padding-left: 20px;
  padding-top: 20px;
  padding-bottom: 10px;
  margin-bottom: 10px;
}

.entradaDatosImporte2 {
  background-color: black;
  color: white;
  padding-left: 20px;
  padding-top: 10px;
  padding-right: 20px;
  padding-bottom: 10px;
  margin-bottom: 10px;
}

.importe1 {
  margin-left: 10px;
  font-size: 25px;
}

.boton-hacerReserva {
  width: 100%;
  background-color: orange;
  color: white;
  font-size: 22px;
  border-color: orange;
}

.importeTotalFinal {
  font-size: 30px;
  font-weight: bold;
  color: skyblue;
}

.importeTotalFinalTitulo {
  font-size: 25px;
  font-weight: bold;
}

/* Tarjetas de puntos de interes */
.columna {
  padding: 0px;
  margin-bottom: 0px;
}

.tarjeta {
  border-top: 1px solid rgb(240, 220, 220);
  border-bottom: 1px solid rgb(240, 220, 220);
  border-left: 1px solid rgb(240, 220, 220);
  border-right: 1px solid rgb(240, 220, 220);
  padding: 10px;
  margin: 0px;
}

.iconoTituloArea {
  font-size: 25px;
  color: #1a55f4;
  margin-right: 10px;
}

.iconoPicker {
  font-size: 25px;
  color: black;
  margin: 0px;
}

.iconoEnTarjeta {
  font-size: 15px;
  color: #1a55f4;
  margin-right: 8px;
}

.infoAdicionaltarjeta {
  margin-top: 5px;
  font-size: 12px;
  color: rgb(128, 128, 128);
}
</style>


<script>
// comunicacion HTTP con RestApi
import axios from "axios";
import SelectorFechaHora from "@/components/SelectorFechaHora.vue";
// constantes para todo el proyecto

import { DateTime } from 'luxon';
// validacion de formularios
import {
  required,
  alphaNum /*, minLength, sameAs */,
} from "vuelidate/lib/validators";
import api from "@/plugins/api";
// traducciones para el datepicker
import { es, fr, en, ca } from "vuejs-datepicker/dist/locale";

export default {
  components: {
    SelectorFechaHora,
  },
  name: "PaginaReservar",
  data: () => ({
    descuentoAplicado:false,
    valorImporteDescuento:'',
    valorImporteSinDescuento:'',
    btnDisabled:false,
    intervaloContador:'',
    cargando: false,
    tiempoRestanteReserva:'',
    swCodigoPromocional:false,
    verPrecioTotal: true,
    descuentoNumero: "",
    informacionCodigoPromocional: "",
    importeReservaSinPromocionSoloNumero: "",
    fechasIncorrectas: false,
    parkingseleccionado: "",
    ciudadSeleccionada: "",
    modelo: "",
    itemsCargados: false,
    matricula: "",
    fechaSalida: "",
    fechaEntrada: "",
    iconoTemperatura: "",
    linkComoLlegarParkingLunaCentro:
    "https://www.google.es/maps/place/Parking+Luna+Centro/@37.171194,-3.6017685,17z/data=!3m1!4b1!4m6!3m5!1s0xd71fdd5288ed97d:0x3cd525c728f6a4b5!8m2!3d37.1711898!4d-3.5991936!16s%2Fg%2F11sb6rty1c?hl=es&entry=ttu&g_ep=EgoyMDI1MDMyNS4xIKXMDSoASAFQAw%3D%3D",
    linkComoLlegarParkingLunaGranada:
    "https://www.google.es/maps/place/Parking+en+Granada+-+Parking+Luna+de+Granada/@37.1712149,-3.6094933,15z/data=!3m1!5s0xd71fc8d4455b6e7:0x7c909faefdd56afd!4m10!1m2!2m1!1sparking+luna+granada!3m6!1s0xd71fc8d7957a415:0x78aa0b0b5a566f01!8m2!3d37.176514!4d-3.6123517!15sChRwYXJraW5nIGx1bmEgZ3JhbmFkYZIBC3BhcmtpbmdfbG904AEA!16s%2Fg%2F11gd67p3jj?hl=es&entry=ttu&g_ep=EgoyMDI1MDMyNS4xIKXMDSoASAFQAw%3D%3D",
    condicion: "",
    tiempo: "",
    ciudad: "Madrid",
    clima: [],
    valido: false,
    temperaturaMaxima: "",
    temperaturaMinima: "",
    temperatura: "",
    tarifaParking: {
      tarifa: null,
      hayTarifa: false,
      cargada: false,
      hayError: false,
      elError: null,
    }, // fin objeto data.tarifaparking

    datosReserva: {
      importeReserva: "",
      importeReservaNumero: 0,
      horaEntrada: "00:00",
      fechaEntrada: null,
      horaSalida: "00:00",
      fechaSalida: null,
      matricula: "",
      modelo: "",
      nombre: "",
      mail: "",
      telefono: "",
      cif: "",
      aceptacionTerminos: false,
      importeReservaSinPromocion: "",
      importeDescuento: "",
      importeDescuentoSoloNumero:"",
      codigoDescuento:"",
      token_reserva:"",
      tiempo_plaza_reservada:""
    }, // fin objeto data.datosReserva
    itemsCiudad: [],
    datosParkingsDisponible: [],
    codigoPromocional: "",
    itemsParkings: [],
    submitted: false,
    verParkings: true,
    traduccionDatepicker: {
      en: en,
      fr: fr,
      ca: ca,
      es: es,
    }, // fin objeto data.traduccionDatepicker

    alerta: {
      mostrar: false,
      texto: "",
    }, //fin objeto alerta

    dialog: false,
    alertaDisponibilidad: {
      mostrar: false,
      texto: "",
    }, //fin objeto alertasds
  }), // fin objeto data

  validations: {
    datosReserva: {
      fechaEntrada: { required },
      fechaSalida: { required },
      matricula: { required, alphaNum },
      modelo: { required },
      color: {},
      crucero: {},
    },
    // un campo a validar
  }, // validacion de formularios con vuelidation
  computed: {
    form() {
      return {
        matricula: this.datosReserva.matricula,
        modelo: this.datosReserva.modelo,
      };
    },
    labelCiudadSeleccionada() {
      return this.$t("labelCiudadSeleccionada");
    },
    labelParkingSeleccionado() {
      return this.$t("labelParkingSeleccionado");
    },
    reglasInicio() {
      return this.$t("reglasInicio");
    },
  },
  methods: {
    reservar() {
      Object.keys(this.form).forEach((f) => {
        if (!this.form[f]) this.formHasErrors = true;
        this.$refs[f].validate(true);
      });
      if (
        this.datosReserva.importeReserva !== "----------" &&
        this.datosReserva.modelo !== "" &&
        this.datosReserva.matricula !== "" &&
        this.parkingseleccionado !== "" &&
        this.compararFechas(this.fechaEntrada) &&
        this.compararFechas(this.fechaSalida)
      ) {
        ///Establecemos los datos
        window.localStorage.setItem(
          "importeReserva",
          this.datosReserva.importeReserva
        );
        window.localStorage.setItem(
          "importeReservaNumero",
          this.datosReserva.importeReservaNumero
        );
        window.localStorage.setItem("fechaEntrada", this.fechaEntrada);
        window.localStorage.setItem("fechaSalida", this.fechaSalida);
        window.localStorage.setItem("horaSalida", "00:00");
        window.localStorage.setItem("horaEntrada", "00:00");
        window.localStorage.setItem("matricula", this.datosReserva.matricula);
        window.localStorage.setItem("modelo", this.datosReserva.modelo);
        window.localStorage.setItem("parking", this.parkingseleccionado);
        window.localStorage.setItem("ciudad", this.ciudadSeleccionada);
        window.localStorage.setItem("tokenReserva", this.datosReserva.token_reserva);
        window.localStorage.setItem("tiempoReserva", this.datosReserva.tiempo_plaza_reservada);

        // añadimos si existe algun descuento por codigo promociona
        window.localStorage.setItem("descuentoAplicado", this.descuentoAplicado);
        window.localStorage.setItem("valorImporteDescuento", this.valorImporteDescuento)
        window.localStorage.setItem("importeReservaSinPromocionSoloNumero", this.datosReserva.importeReservaSinPromocionSoloNumero)
        window.localStorage.setItem("importeReservaSinPromocion", this.datosReserva.importeReservaSinPromocion)
        window.localStorage.setItem("importeDescuento", this.datosReserva.importeDescuento)
        window.localStorage.setItem("importeDescuentoSoloNumero", this.datosReserva.importeDescuentoSoloNumero)
        window.localStorage.setItem("codigoDescuento", this.datosReserva.codigoDescuento)

        this.$router.push({ path: "/continuarReserva" });
      } else {
        if (!this.compararFechas(this.fechaEntrada)) {
          this.$root.$dialogo.activarDialogo(
            this.$t("fechaAnterior"),
            this.$t("fechaAnteriorDescripcion"),
            ["OK"]
          );
        }
      }
    },

    cadenaTiempo: function (aTiempo) {
      return aTiempo + " " + this.$t("minutos");
    }, // fin metodo cadenaTiempo

    cadenaDuracion: function (aDuracionReserva) {
      aDuracionReserva += 1;

      if (1 == aDuracionReserva) {
        return aDuracionReserva + " " + this.$t("dia");
      } else {
        return aDuracionReserva + " " + this.$t("dias");
      }
    }, // fin metodo cadenaDuracion

    obtenerDatosDeParkingsDisponibles() {
      api
        .obtenerDatosDeParkings()
        .then((res) => {
          this.datosParkingsDisponible = res.data.datos;
          res.data.ciudades.forEach((element) => {
            this.itemsCiudad.push(element["ciu"]);
          });
          res.data.datos.forEach((elemento) => {
            if (elemento["ciu"] === this.ciudadSeleccionada) {
              this.itemsParkings.push(elemento["nom"]);
            }
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
    //Change de select ciudad
    obtenerParkingsDespuuesDeSeleccionarCiudad() {
      this.itemsParkings = [];
      this.parkingseleccionado = "";
      this.datosParkingsDisponible.forEach((element) => {
        if (element["ciu"] === this.ciudadSeleccionada) {
          this.itemsParkings.push(element["nom"]);
        }
      });
      this.obtenerTiempo();
      this.verParkings = false;
    },

    // inicializamos el contador de tiempo maximo para realizar la reserva
    inicializarContadorReserva(){

      let fechaFinReserva = DateTime.fromISO(this.datosReserva.tiempo_plaza_reservada)

      let momentoActual = DateTime.now()

      let diferenciaEntreFechas = fechaFinReserva.diff(momentoActual, [ 'minutes', 'seconds']);

      if (diferenciaEntreFechas.as('seconds') <= 0) {
        this.$root.$dialogo.activarDialogo(
            this.$t("tituloFinReserva"),
            this.$t("textoFinReserva"),
            ["OK"]
          );
        
        setTimeout(() => {
          this.$router.push({ path: "/" });
        }, 4000);

        clearInterval(this.intervaloContador)
        
        return;
      }

      const { minutes, seconds } = diferenciaEntreFechas.toObject();
      this.tiempoRestanteReserva = ` ${Math.floor(minutes)}m ${Math.floor(seconds)}s`;
      
    },

    //Comparamos las fechas respecto a la fecha actual para verificar
    compararFechas(fechaComparacion) {
      let fechaActual = DateTime.now().toFormat("yyyy-MM-dd HH:mm") + ":00";

      if (fechaActual > fechaComparacion) {
        return false;
      } else return true;
    },

    verificarCodigoPromocional(){
      this.descuentoAplicado = false;
      if (this.codigoPromocional.length > 8) {

        let fechaSalidaModificado = this.fechaSalida.toString();
        fechaSalidaModificado =
          fechaSalidaModificado.substring(0, 10) +
          "T" +
          fechaSalidaModificado.substring(11, 19);

        let fechaEntradaModificado = this.fechaEntrada.toString();
        fechaEntradaModificado =
          fechaEntradaModificado.substring(0, 10) +
          "T" +
          fechaEntradaModificado.substring(11, 19);

        let peticion = {
          'codigo':this.codigoPromocional,
          'entrada':fechaEntradaModificado,
          'salida': fechaSalidaModificado,
          'parking':this.parkingseleccionado
        }
        
        api.verificarCodigoPromocional(peticion)
          .then((res) => {
            if (res.data.resultado == "valido") {
              this.datosReserva.importeReservaNumero = res.data.precio;
              this.datosReserva.importeReserva =
                res.data.precio.toFixed(2) + " €";
              this.descuentoNumero =
                parseFloat(this.datosReserva.importeReservaSinPromocion) -
                res.data.precio;
              this.datosReserva.importeDescuento =
                this.descuentoNumero.toFixed(2) + " €";
              this.datosReserva.importeDescuentoSoloNumero = this.descuentoNumero.toFixed(2);

              this.datosReserva.codigoDescuento = this.codigoPromocional;
              this.valido = true;
              this.informacionCodigoPromocional = this.$t(
                "codigoPromocionalValido"
              );

              this.descuentoAplicado = true;
              this.valorImporteDescuento = res.data.precio;

            } else if (res.data.resultado == "No valido") {
              this.valido = false;
              this.informacionCodigoPromocional = this.$t(
                "codigoPromocionalNoValido"
              );
            } else if (res.data.resultado == "minimo") {
              this.valido = false;
              this.informacionCodigoPromocional = res.data.conuso;
            } else if (res.data.resultado == "caducado") {
              this.valido = false;
              // this.informacionCodigoPromocional = res.data.conuso;
              this.informacionCodigoPromocional = this.$t("codigoPromocionalCaducado");
            } else if (res.data.resultado == "Usado") {
              this.valido = false;
              this.informacionCodigoPromocional = this.$t(
                "codigoPromocionalUsado"
              );
            }

            if (res.data.resultado !== "valido") {
              if (this.datosReserva.importeDescuento.length > 0) {
                this.datosReserva.importeReserva =
                  this.datosReserva.importeReservaSinPromocion;
                this.datosReserva.importeReservaNumero =
                  this.datosReserva.importeReservaSinPromocionSoloNumero;
                this.datosReserva.importeDescuento = "";
              }
            }
            this.verPrecioTotal = true;
          });

      }else {
        this.datosReserva.importeReserva =
          this.datosReserva.importeReservaSinPromocion;
        this.datosReserva.importeReservaNumero =
          this.datosReserva.importeReservaSinPromocionSoloNumero;
        this.informacionCodigoPromocional = "";
        this.datosReserva.importeDescuento = "";
      }

    },

    //Validamos el codigo promocional.
    // verificarValidezCodigoPromocional() {
    //   if (this.codigoPromocional.length > 8) {
    //     let fechaSalidaModificado = this.fechaSalida.toString();
    //     fechaSalidaModificado =
    //       fechaSalidaModificado.substring(0, 10) +
    //       "T" +
    //       fechaSalidaModificado.substring(11, 19);

    //     let fechaEntradaModificado = this.fechaEntrada.toString();
    //     fechaEntradaModificado =
    //       fechaEntradaModificado.substring(0, 10) +
    //       "T" +
    //       fechaEntradaModificado.substring(11, 19);

    //     api
    //       .verificarValidezCodigoPromocional(
    //         this.codigoPromocional,
    //         fechaEntradaModificado,
    //         fechaSalidaModificado,
    //         this.parkingseleccionado
    //       )
    //       .then((res) => {
    //         if (res.data.resultado == "valido") {
    //           this.datosReserva.importeReservaNumero = res.data.precio;
    //           this.datosReserva.importeReserva =
    //             res.data.precio.toFixed(2) + " €";
    //           this.descuentoNumero =
    //             parseFloat(this.datosReserva.importeReservaSinPromocion) -
    //             res.data.precio;
    //           this.datosReserva.importeDescuento =
    //             this.descuentoNumero.toFixed(2) + " €";
    //           this.valido = true;
    //           this.informacionCodigoPromocional = this.$t(
    //             "codigoPromocionalValido"
    //           );
    //         } else if (res.data.resultado == "No valido") {
    //           this.valido = false;
    //           this.informacionCodigoPromocional = this.$t(
    //             "codigoPromocionalNoValido"
    //           );
    //         } else if (res.data.resultado == "minimo") {
    //           this.valido = false;
    //           this.informacionCodigoPromocional = res.data.conuso;
    //         } else if (res.data.resultado == "caducado") {
    //           this.valido = false;
    //           this.informacionCodigoPromocional = res.data.conuso;
    //           // this.informacionCodigoPromocional = this.$t("codigoPromocionalCaducado");
    //         } else if (res.data.resultado == "Usado") {
    //           this.valido = false;
    //           this.informacionCodigoPromocional = this.$t(
    //             "codigoPromocionalUsado"
    //           );
    //         }

    //         if (res.data.resultado !== "valido") {
    //           if (this.datosReserva.importeDescuento.length > 0) {
    //             this.datosReserva.importeReserva =
    //               this.datosReserva.importeReservaSinPromocion;
    //             this.datosReserva.importeReservaNumero =
    //               this.datosReserva.importeReservaSinPromocionSoloNumero;
    //             this.datosReserva.importeDescuento = "";
    //           }
    //         }
    //         this.verPrecioTotal = true;
    //       });
    //   } else {
    //     this.datosReserva.importeReserva =
    //       this.datosReserva.importeReservaSinPromocion;
    //     this.datosReserva.importeReservaNumero =
    //       this.datosReserva.importeReservaSinPromocionSoloNumero;
    //     this.informacionCodigoPromocional = "";
    //     this.datosReserva.importeDescuento = "";
    //   }
    // },

    obtenerPrecioYDisponibilidad() {

      this.btnDisabled = true;
      let fechaSalidaModificado = this.fechaSalida.toString();
      fechaSalidaModificado =
        fechaSalidaModificado.substring(0, 10) +
        "T" +
        fechaSalidaModificado.substring(11, 19);

      let fechaEntradaModificado = this.fechaEntrada.toString();
      fechaEntradaModificado =
        fechaEntradaModificado.substring(0, 10) +
        "T" +
        fechaEntradaModificado.substring(11, 19);
      if (this.datosReserva.matricula === "" && this.parkingseleccionado) {
        api
          .obtenerPlazasDisponibles(
            "4587PPP",
            fechaEntradaModificado,
            fechaSalidaModificado,
            this.parkingseleccionado
          )
          .then((res) => {

            this.itemsCargados = true;
            
            
            let fechaActualmas1hora = DateTime.now().plus({ hours: 1 });
            if (res.data.plazas_maximas === "Completo") {
              this.$root.$dialogo.activarDialogo(
                this.$t("completo"),
                this.$t("completoDescripcion"),
              
                ["OK"]
              );
              let fechaSiguiente = DateTime.now().plus({ days: 1 });
              this.fechaSalida =
                fechaSiguiente.toFormat("yyyy-MM-dd HH:mm") + ":00";
              this.fechaEntrada =
                fechaActualmas1hora.toFormat("yyyy-MM-dd HH:mm") + ":00";
            }else if (res.data.plazas.datos.printable_total_amount === undefined) {
              this.fechasIncorrectas = true;
              this.$root.$dialogo.activarDialogo(
                this.$t("fechasIncorrectas"),
                this.$t("fechasIncorrectasDescripcion") ,
                ["OK"]
              );
              let fechaSiguiente = DateTime.now().plus({ days: 1 });
              this.fechaSalida =
                fechaSiguiente.toFormat("yyyy-MM-dd HH:mm") + ":00";
              this.fechaEntrada =
                fechaActualmas1hora.toFormat("yyyy-MM-dd HH:mm") + ":00";
            }  else {
              this.$root.$dialogo.cerrarDialogo();
              this.fechasIncorrectas = false;
              this.datosReserva.importeReserva =
                res.data.plazas.datos.printable_total_amount;
              this.datosReserva.importeReservaNumero =
                res.data.plazas.datos.total_amount;
              this.datosReserva.importeReservaSinPromocion =
                res.data.plazas.datos.printable_total_amount;
              this.datosReserva.importeReservaSinPromocionSoloNumero =
                res.data.plazas.datos.total_amount;
 

              // guardamos el token y la fecha de expiracion 
              this.datosReserva.token_reserva = res.data.plazas.datos.availability_request_token
              this.datosReserva.tiempo_plaza_reservada =  res.data.plazas.datos.availability_request_expire_time

              // inicializamos el contador 
              this.inicializarContadorReserva();
              this.intervaloContador = setInterval(this.inicializarContadorReserva, 1000);
              this.btnDisabled = false;
              ///Comprobamos si tiene codigo promocional añadido y lo verificamos para aplicarle el descuento
              if (this.codigoPromocional.length > 8) {
                this.verPrecioTotal = false;
                this.verificarCodigoPromocional();
              }
            }
          });
      } else {
        api
          .obtenerPlazasDisponibles(
            this.datosReserva.matricula,
            fechaEntradaModificado,
            fechaSalidaModificado,
            this.parkingseleccionado
          )
          .then((res) => {
            this.itemsCargados = true;
            let fechaActualmas1hora = DateTime.now().plus({ hours: 1 });
            if (res.data.plazas.datos.printable_total_amount === undefined) {
              this.fechasIncorrectas = true;
              this.$root.$dialogo.activarDialogo(
                this.$t("fechasIncorrectas"),
                this.$t("fechasIncorrectasDescripcion"),
                ["OK"]
              );
              let fechaSiguiente = DateTime.now().plus({ days: 1 });
              this.fechaSalida =
                fechaSiguiente.toFormat("yyyy-MM-dd HH:mm") + ":00";
              this.fechaEntrada =
                fechaActualmas1hora.toFormat("yyyy-MM-dd HH:mm") + ":00";
            } else if (res.data.plazas_maximas === "Completo") {
              this.$root.$dialogo.activarDialogo(
                this.$t("completo"),
                this.$t("completoDescripcion"),
                ["OK"]
              );
              let fechaSiguiente = DateTime.now().plus({ days: 1 });
              this.fechaSalida =
                fechaSiguiente.toFormat("yyyy-MM-dd HH:mm") + ":00";
              this.fechaEntrada =
                fechaActualmas1hora.toFormat("yyyy-MM-dd HH:mm") + ":00";
            } else {
              this.$root.$dialogo.cerrarDialogo();
              this.fechasIncorrectas = false;
              this.datosReserva.importeReserva =
                res.data.plazas.datos.printable_total_amount;
              this.datosReserva.importeReservaNumero =
                res.data.plazas.datos.total_amount;
              this.datosReserva.importeReservaSinPromocion =
                res.data.plazas.datos.printable_total_amount;
              this.datosReserva.importeReservaSinPromocionSoloNumero =
                res.data.plazas.datos.total_amount;

                            
              // guardamos el token y la fecha de expiracion 
              this.datosReserva.token_reserva = res.data.plazas.datos.availability_request_token
              this.datosReserva.tiempo_plaza_reservada =  res.data.plazas.datos.availability_request_expire_time

              // inicializamos el contador
              this.inicializarContadorReserva();
              setInterval(this.inicializarContadorReserva, 1000);
              this.btnDisabled = false;
              ///Comprobamos si tiene codigo promocional añadido y lo verificamos para aplicarle el descuento
              if (this.codigoPromocional.length == 9) {
                this.verPrecioTotal = false;
                this.verificarCodigoPromocional();
              }
            }
          });
      }

      this.cargando = true;
    },
    //Cambiamos la fecha de salida cuando cambiamos la de entrada
    cambiarFechaSalida() {
      let fechaEntradaReplace = this.fechaEntrada.replace(" ", "T");
      let fechaISO = DateTime.fromISO(fechaEntradaReplace);
      let fecha = fechaISO.plus({ days: 1 });
      fecha = fecha.plus({ hours: 1 });
      this.fechaSalida = fecha.toFormat("yyyy-MM-dd HH:mm") + ":00";
    },
    obtenerTiempo() {

      axios
        .get(
          "https://weather-proxy.freecodecamp.rocks/api/current?lat=37.18817&lon=-3.60667"
        )
        .then((res) => {
          if (res.data.sys.country === "ES") {
            this.clima = res.data;
            this.temperatura = this.clima.main.temp;
            this.temperaturaMaxima = this.clima.main.temp_max;
            this.temperaturaMinima = this.clima.main.temp_min;
            this.iconoTemperatura = this.clima.weather[0].icon;
          } 
        });
      
    },

    //Convertirmos
    aFahrenheit(celsius) {
      let fare = (celsius * 9) / 5 + 32;
      let grados = ((fare - 32) * 5) / 9;
      return Math.round(grados);
    },
  }, // fin methods

  watch: {
    codigoPromocional() {
      //Verificamos el codigo promocional
      this.verificarCodigoPromocional();
    },
    fechaSalida() {
      if (this.itemsCargados == true) 
        this.obtenerPrecioYDisponibilidad();
    },
    fechaEntrada() {
      if (this.itemsCargados == true) {
        this.cambiarFechaSalida();
        // this.obtenerPrecioYDisponibilidad();
      }
    },
    parkingseleccionado() {
      if (this.itemsCargados == true) this.obtenerPrecioYDisponibilidad();
    },
  },
  created() {
    this.obtenerTiempo();
    this.obtenerDatosDeParkingsDisponibles();

    this.parkingseleccionado = window.localStorage.getItem("parking");
    this.ciudadSeleccionada = window.localStorage.getItem("ciudad");
    let fechaActualmas1hora = DateTime.now().plus({ hours: 1 });
    let fechaSiguiente = DateTime.now().plus({ days: 1 });
    fechaSiguiente = fechaSiguiente.plus({ hours: 2 });
    this.fechaSalida = fechaSiguiente.toFormat("yyyy-MM-dd HH:mm") + ":00";
    this.fechaEntrada =
      fechaActualmas1hora.toFormat("yyyy-MM-dd HH:mm") + ":00";
    if (window.localStorage.getItem("parking"))
      this.parkingseleccionado = window.localStorage.getItem("parking");
    if (window.localStorage.getItem("ciudad"))
      this.ciudadSeleccionada = window.localStorage.getItem("ciudad");
    if (window.localStorage.getItem("fechaSalida"))
      this.fechaSalida = window.localStorage.getItem("fechaSalida");
    if (window.localStorage.getItem("fechaEntrada"))
      this.fechaEntrada = window.localStorage.getItem("fechaEntrada");
    if (window.localStorage.getItem("matricula"))
      this.datosReserva.matricula = window.localStorage.getItem("matricula");
    if (window.localStorage.getItem("modelo"))
      this.datosReserva.modelo = window.localStorage.getItem("modelo");
    this.obtenerPrecioYDisponibilidad();
  },
  // fin evento mounted
};
</script>
